import { createProgressToast, ProgressToastFunctions } from 'components/toasts/createProgressToast';
import { SuccessfulUsersInvitationHint } from 'features/profilePage/SuccessfulUsersInvitationHint';
import { useRef } from 'react';

export const useShowSuccessToast = () => {
  const progressToast = useRef<ProgressToastFunctions | null>();

  const showSuccessToast = (callback?: () => void) => {
    progressToast.current = createProgressToast(<SuccessfulUsersInvitationHint />);
    progressToast.current?.close();
    progressToast.current?.success({
      render: <SuccessfulUsersInvitationHint />,
    });

    if (callback) {
      callback();
    }
  };

  return {
    showSuccessToast,
  };
};
